"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var URL =
/*#__PURE__*/
function () {
  function URL(connector) {
    _classCallCheck(this, URL);

    this.connector = connector;
  }

  _createClass(URL, [{
    key: "to",
    value: function to(pathname) {
      return this.connector.historyManager.createHref(pathname);
    }
  }, {
    key: "name",
    value: function name(_name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathname = this.connector.routeMatcher.compileByName(_name, parameters);
      return this.connector.historyManager.createHref(pathname);
    }
  }]);

  return URL;
}();

exports.default = URL;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvVVJMLmpzIl0sIm5hbWVzIjpbIlVSTCIsImNvbm5lY3RvciIsInBhdGhuYW1lIiwiaGlzdG9yeU1hbmFnZXIiLCJjcmVhdGVIcmVmIiwibmFtZSIsInBhcmFtZXRlcnMiLCJyb3V0ZU1hdGNoZXIiLCJjb21waWxlQnlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0lBQXFCQSxHOzs7QUFDbkIsZUFBWUMsU0FBWixFQUF1QjtBQUFBOztBQUNyQixTQUFLQSxTQUFMLEdBQWlCQSxTQUFqQjtBQUNEOzs7O3VCQUVFQyxRLEVBQVU7QUFDWCxhQUFPLEtBQUtELFNBQUwsQ0FBZUUsY0FBZixDQUE4QkMsVUFBOUIsQ0FBeUNGLFFBQXpDLENBQVA7QUFDRDs7O3lCQUVJRyxLLEVBQXVCO0FBQUEsVUFBakJDLFVBQWlCLHVFQUFKLEVBQUk7QUFDMUIsVUFBTUosUUFBUSxHQUFHLEtBQUtELFNBQUwsQ0FBZU0sWUFBZixDQUE0QkMsYUFBNUIsQ0FDZkgsS0FEZSxFQUVmQyxVQUZlLENBQWpCO0FBSUEsYUFBTyxLQUFLTCxTQUFMLENBQWVFLGNBQWYsQ0FBOEJDLFVBQTlCLENBQXlDRixRQUF6QyxDQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBjbGFzcyBVUkwge1xuICBjb25zdHJ1Y3Rvcihjb25uZWN0b3IpIHtcbiAgICB0aGlzLmNvbm5lY3RvciA9IGNvbm5lY3RvcjtcbiAgfVxuXG4gIHRvKHBhdGhuYW1lKSB7XG4gICAgcmV0dXJuIHRoaXMuY29ubmVjdG9yLmhpc3RvcnlNYW5hZ2VyLmNyZWF0ZUhyZWYocGF0aG5hbWUpO1xuICB9XG5cbiAgbmFtZShuYW1lLCBwYXJhbWV0ZXJzID0ge30pIHtcbiAgICBjb25zdCBwYXRobmFtZSA9IHRoaXMuY29ubmVjdG9yLnJvdXRlTWF0Y2hlci5jb21waWxlQnlOYW1lKFxuICAgICAgbmFtZSxcbiAgICAgIHBhcmFtZXRlcnNcbiAgICApO1xuICAgIHJldHVybiB0aGlzLmNvbm5lY3Rvci5oaXN0b3J5TWFuYWdlci5jcmVhdGVIcmVmKHBhdGhuYW1lKTtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/URL.js
// module id = 134
// module chunks = 0